import Vue from 'vue';

const END_POINT = '/rp';

const getContact = (id) => Vue.axios.get(END_POINT + '/' + id);

const getAllContacts = (data) => Vue.axios.get(END_POINT, { params: data });

const createContact = (contact) => Vue.axios.post(END_POINT, contact);

const createAllContacts = (Contacts) =>
  Vue.axios.post(END_POINT + '/all', Contacts);

const updateContact = (contact) =>
  Vue.axios.put(END_POINT + '/' + contact.id, contact);

const deleteContact = (id) => Vue.axios.delete(END_POINT + '/' + id);

export {
  getContact,
  getAllContacts,
  createContact,
  createAllContacts,
  updateContact,
  deleteContact,
};
